import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $signInFormTranslations = combine(i18n.$t, ({ t }) => ({
  phoneNumber: {
    label: t('phone_number'),
    errors: {
      minLength: t('enter_phone_number'),
    },
  },
  submitButton: t('sign_in'),
  submittingButton: t('signing_in'),
}))
